import { IonContent } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign.ts';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { canLogEvents } from '@/utils/canLogEvents';

import { getSummaryScreenConfig } from '../../utils/getSummaryScreenConfig';

import {
  ContentContainerStyles,
  PageStyles,
  PlayerContainerStyles,
  SubtitleStyles,
} from './SummaryFinal.styles';

export const SummaryFinal: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Summary Final',
      });
    }
  }, []);

  const { wizard } = useOnboarding();
  const notes = webCampaign.getLayoutNotes();
  const config = getSummaryScreenConfig('summary-final', notes);

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <PageStyles background="domination" mainImage={config.mainImage}>
      <IonContent>
        <ContentContainerStyles>
          <PlayerContainerStyles>
            <Player
              src="/assets/layout-own-ai-dominate/summary_screens/summary_final.json"
              autoplay
              loop={false}
              keepLastFrame
            />
          </PlayerContainerStyles>
          <OwnAiTitle className={'title'}>The game deepens</OwnAiTitle>
          <SubtitleStyles color={'neutral-white'} className={'subtitle'}>
            You've pleased me so far.
            <br />
            Don't lose that rhythm now
          </SubtitleStyles>
        </ContentContainerStyles>
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonText={'Yes, Mistress'}
        />
      </IonContent>
    </PageStyles>
  );
};
